<template>
    <auth-admin-layout>
        <Head>
            <title>Login</title>
        </Head>

        <div class="auth-form">
            <div class="auth-form--form">
                <form @submit.prevent="submit">
                    <card class="card--minify card--message error" v-if="form.errors.account">
                        <card-content v-html="form.errors.account"></card-content>
                    </card>

                    <form-input type="email" id="email" label="Email Adresse" v-model="form.email"
                                placeholder="john@doe.com" :error="form.errors.email" icon="email-mail-checkmark"
                                autocomplete="email" autofocus/>
                    <form-password type="password" id="password" label="Passwort" v-model="form.password"
                                   :error="form.errors.password"/>

                    <div class="form-actions">
                        <form-checkbox id="remember" option="angemeldet bleiben" v-model:checked="form.remember" />
                        <form-button type="submit" color="secondary" icon="lock-shield-prote" :disabled="form.processing" :class="{'btn--processing': form.processing}"><translate>Login</translate></form-button>
                    </div>
                </form>
            </div>
        </div>

    </auth-admin-layout>
</template>

<script>
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';
import {useForm} from '@inertiajs/vue3';
import AuthAdminLayout from '@partfactory/Layouts/AuthAdminLayout';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormPassword from '@partfactory/Shared/Form/FormPassword';
import CardContent from '@partfactory/Shared/Card/CardContent';
import Card from '@partfactory/Shared/Card/Card';

export default {
    name: 'Login',
    components: {
        Card,
        CardContent,
        FormPassword,
        FormButton,
        AuthAdminLayout,
        FormCheckbox,
        FormInput,
    },
    setup () {
        const form = useForm({
            email: null,
            password: null,
            remember: false,
        });

        return { form };
    },
    methods: {
        submit() {
            this.form
            .transform(data => ({
                ...data,
                remember: this.form.remember ? 'true' : '',
                _token: this.$page.props.csrf_token,
            }))
            .post(this.$$route('login'), {
                onError: () => this.form.reset('password'),
                onSuccess: () => this.form.reset('password'),
            });
        }
    }
};
</script>
